import loader from './loader';
import toastr from './toastr';
import tableRow from './table-row';
import confirmDelete from './confirm-delete';
import tags from './tags';
import resources from './resources';
import search from './search';
import orderer from './orderer';
import fixedActions from './fixed-actions';
import date from './date';
import calendar from './calendar';

export default () => {
  [
    loader,
    toastr,
    tableRow,
    confirmDelete,
    orderer,
    tags,
    fixedActions,
    resources,
    search,
    calendar,
    date,
  ].map(plugin => plugin.call(this));
};



// WEBPACK FOOTER //
// ./src/plugins/index.js